import React from 'react';

export default class BaseFormComponent extends React.Component {

    /**
     * @type {BaseModel}
     */
    model = null;

    /**
     * @type {BaseRepository}
     */
    repository = null;

    constructor(props) {
        super(props);

        this.initRepository();
        this.initState();
    }

    initState() {
        this.state = {
            errors: {},
            error_message: null,
            model: {},
            loading: true,
            process: false,
            redirect: null
        };
    }

    initRepository() {
        throw 'Please initialize repository in initRepository';
    }

    makeNewModel() {
        throw 'Please make new model in makeNewModel';
    }

    loadById(id) {
        return this.repository.fetchById(this.props.match.params.id);
    }

    initModel() {
        return new Promise((resolve, reject) => {
            if (this.props.match && this.props.match.params.id) {
                this.loadById(this.props.match.params.id).then((model) => {
                    resolve(model);
                }, (err) => {
                    reject(err);
                });
            } else {
                resolve(this.makeNewModel());
            }
        });
    }

    componentDidMount() {
        this.initModel().then((model) => {
            this.model = model;
            this.setState({
                loading: false,
                model: this.model
            });
        }, (err) => {
            console.log(err);
        });
    }

    onChangeInput(event) {
        let name = event.target.name;
        let value = event.target.value;
        if (this.model.hasOwnProperty(name)) {
            this.model[name] = value;
        }
    }

    onChangeSelect(data, event) {
        let values = [];
        if (data) {
            values = data.map((datum) => ((datum.value)));
        }

        if (this.model.hasOwnProperty(event.name)) {
            this.model[event.name] = values;
        }
    }

    onChangeCheckbox(event) {
        let name = event.target.name;
        let value = $(event.target).is(':checked');
        if (this.model.hasOwnProperty(name)) {
            this.model[name] = value;
        }
    }

    onSubmit() {
        this.setState({
            process: true,
        });
        this.save().then((data) => {
            this.setState({
                process: false,
                errors: {},
                error_message: null
            });
            this.onSave(data);
        }, (err) => {
            this.setState({
                process: false,
                errors: err.data,
                error_message: err.message
            });
        });
    }

    save() {
        return this.repository.save(this.model);
    }

    onSave(model) {
    }

}